import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	deleteAnalysisButton: {
		color: themeColors.colors.error[400],
		borderColor: themeColors.colors.error[400],
		fontWeight: "normal"
	},
	closerAvatar: {
		width: "40px",
		height: "40px",
		backgroundColor: themeColors.colors.system.purple[600],
		color: themeColors.colors.base.white,
		fontSize: "0.875rem",
		fontWeight: 700
	},
	eyebrowLabel: {
		fontSize: "0.7rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[500],
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	},
	summaryHeading: {
		fontSize: "1rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[900]
	},
	dateSecondary: {
		fontSize: "0.75rem",
		color: themeColors.colors.system.gray[500]
	},
	detailTitle: {
		fontWeight: 600,
		wordWrap: "break-word",
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis"
	}
}))

export default useStyles
